import { Icon404 } from './404';
import { AppleIcon } from './apple';
import { ArrowDown } from './arrow-down';
import { ArrowDownBlueCircle } from './arrow-down-blue-circle';
import { AttachIcon } from './attach';
import { CancelIcon } from './cancel';
import { CancelBigIcon } from './cancel-big';
import { CareersIcon } from './careers';
import { CatIcon } from './cat';
import { CatCutIcon } from './cat-cut';
import { CircleIcon } from './circle';
import { CloseModal } from './close-modal';
import { ContactsIcon } from './contacts';
import { DiscordIcon } from './discord';
import { DiviceIcon } from './divice';
import { DownloadIcon } from './download';
import { DropdownIcon } from './dropdown';
import { FacebookIcon } from './facebook';
import { FileInputIcon } from './file-input';
import { FlashIcon } from './flash';
import { GamesTitleIcon } from './games';
import { GooglePlayIcon } from './google-play';
import { JoinTeamIcon } from './join-team';
import { LightningGreenCircle } from './ligning-green-circle';
import { LinkedinIcon } from './linked-in';
import { LoadingIcon } from './loading';
import { LogoIcon } from './logo';
import { MetaIcon } from './meta';
import { NewForldersIcon } from './new-folder';
import { NewFolderGamesTitle } from './new-folder-games';
import { NewFoldersGame } from './new-folders-game';
import { NewFoldersGameMobile } from './new-folders-game-mobile';
import { PhoneIcon } from './phone';
import { PolicyIcon } from './policy';
import { PrivacyIcon } from './privacy';
import { StarIcon } from './star';
import { SteamIcon } from './steam';
import { TikTokIcon } from './tik-tok';
import { XIcon } from './x';
import { YoutubeIcon } from './youtube';

export const icons = {
  apple: AppleIcon,
  arrowDown: ArrowDown,
  arrowDownBlueCircle: ArrowDownBlueCircle,
  attach: AttachIcon,
  cancel: CancelIcon,
  cancelBig: CancelBigIcon,
  careers: CareersIcon,
  cat: CatIcon,
  catCut: CatCutIcon,
  circle: CircleIcon,
  closeModal: CloseModal,
  contacts: ContactsIcon,
  discord: DiscordIcon,
  games: GamesTitleIcon,
  divice: DiviceIcon,
  download: DownloadIcon,
  dropdown: DropdownIcon,
  fileInput: FileInputIcon,
  joinTeam: JoinTeamIcon,
  404: Icon404,
  loading: LoadingIcon,
  newfoldersgame: NewFoldersGame,
  newfolersgameMobile: NewFoldersGameMobile,
  newFolder: NewForldersIcon,
  newFolderGames: NewFolderGamesTitle,
  facebook: FacebookIcon,
  flash: FlashIcon,
  googlepay: GooglePlayIcon,
  linkedin: LinkedinIcon,
  lightningGreenCircle: LightningGreenCircle,
  logo: LogoIcon,
  meta: MetaIcon,
  phone: PhoneIcon,
  policy: PolicyIcon,
  privacy: PrivacyIcon,
  star: StarIcon,
  steam: SteamIcon,
  tiktok: TikTokIcon,
  x: XIcon,
  youtube: YoutubeIcon,
} as const;
